import React from "react";
import { Form, Formik } from "formik";
import { Box, Button, DialogActions, TextField } from "@mui/material";
import { usePrinciplesForm } from "../hooks/usePrinciplesForm";

function PrinciplesForm({ editMode, currentPrinciple, setOpen, handleClose }) {
  const { validationSchema, initialValues, handleSubmit } = usePrinciplesForm({
    editMode,
    currentPrinciple,
    setOpen,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        getFieldProps,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Box sx={{ p: 3 }}>
              <TextField
                fullWidth
                id="principleNumber"
                name="principleNumber"
                label="Principle Number"
                variant="outlined"
                margin="normal"
                value={values.principleNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("principleNumber")}
                error={
                  touched.principleNumber && Boolean(errors.principleNumber)
                }
                helperText={touched.principleNumber && errors.principleNumber}
              />

              <TextField
                fullWidth
                id="name"
                name="name"
                label="Name"
                variant="outlined"
                margin="normal"
                multiline
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("name")}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />

              <TextField
                fullWidth
                id="description"
                name="description"
                label="Description"
                variant="outlined"
                margin="normal"
                multiline
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("description")}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
              />

              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {editMode ? "Update" : "Create"}
                </Button>
              </DialogActions>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}

export default PrinciplesForm;
